import base_mutations from '@/store/modules/base/mutations.js'

export default {
    ...base_mutations
}